
(function () {
  'use strict';

  const hiddenChoices = new Set(
    (window.hiddenGloboChoices || [])
      .map(value => String(value).trim().toLowerCase())
      .filter(Boolean)
  );

  const GROUP = '.gpo-element.gpo-form__group';
  const ITEM = '.gpo-ov-item';
  const COLOR_GROUP = '[data-element-id^="color-swatches-"]';

  function normalize(value) {
    return String(value || '').trim().toLowerCase();
  }

  function getValue(item) {
    const input = item.querySelector('input');

    // Globo stores the actual option value here.
    return normalize(
      input?.value ||
      item.querySelector('.gpo-ov-title')?.innerText ||
      item.innerText
    );
  }

  function hideElement(element) {
    if (element.dataset.krFilterHidden !== 'true') {
      element.dataset.krOriginalDisplay =
        element.style.getPropertyValue('display');

      element.dataset.krOriginalPriority =
        element.style.getPropertyPriority('display');
    }

    element.dataset.krFilterHidden = 'true';

    element.style.setProperty(
      'display',
      'none',
      'important'
    );
  }

  function restoreElement(element) {
    if (element.dataset.krFilterHidden !== 'true') return;

    const original = element.dataset.krOriginalDisplay;
    const priority = element.dataset.krOriginalPriority;

    if (original) {
      element.style.setProperty('display', original, priority);
    } else {
      element.style.removeProperty('display');
    }

    delete element.dataset.krFilterHidden;
    delete element.dataset.krOriginalDisplay;
    delete element.dataset.krOriginalPriority;
  }

  function filterChoices() {
    document.querySelectorAll(GROUP).forEach(group => {
      const isColorGroup = group.matches(COLOR_GROUP) ||
        group.querySelector('input[data-type="color-swatches"]');

      const items = [...group.querySelectorAll(ITEM)];

      // Hide matching choices in color and button/radio groups.
      items.forEach(item => {
        const value = getValue(item);

        if (hiddenChoices.has(value)) {
          hideElement(item);
        } else {
          restoreElement(item);
        }
      });

      if (!isColorGroup) return;

      // Count the colors remaining after filtering.
      const remaining = items.filter(item =>
        item.querySelector('input[data-type="color-swatches"]') &&
        item.dataset.krFilterHidden !== 'true'
      );

      // Hide the whole color group, including its heading,
      // when no color choices remain.
      if (remaining.length === 0) {
        hideElement(group);
        return;
      }

      // Restore our group hiding only when Globo says it should show.
      if (group.dataset.cloDisplay !== 'hide') {
        restoreElement(group);
      }

      // If exactly one color remains, select it when possible.
      // Globo uses radio inputs, which cannot be deselected by
      // clicking an already-selected radio option.
      if (
        remaining.length === 1 &&
        group.dataset.cloDisplay !== 'hide'
      ) {
        const input = remaining[0].querySelector(
          'input[data-type="color-swatches"]'
        );

        if (input && !input.checked && !input.disabled) {
          input.click();
        }
      }
    });
  }

  filterChoices();

  // Reapply after Globo changes options or conditional visibility.
  const observer = new MutationObserver(() => {
    filterChoices();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
})();
